<ng-template #modal size="sm">    
    <ng-content></ng-content>
</ng-template>